import axios from './http';
import { CancelTokenSource } from 'axios';
import {
  TestLaboratoryDto,
  TestLaboratorySearchRequest,
  UpsertTestLaboratoryDto
} from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/test-laboratory`;

export const getAllTestLaboratory = (source: CancelTokenSource): Promise<Array<TestLaboratoryDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then(response => response.data);
};

export const searchTestLaboratory = (testLaboratorySearchRequest: Partial<TestLaboratorySearchRequest>,
                                     source: CancelTokenSource): Promise<Array<TestLaboratoryDto>> => {

  return axios
      .post(`${apiUri}/search`, testLaboratorySearchRequest, {cancelToken: source.token})
      .then(response => response.data)

};

export const findTestLaboratoryById = (id: number, source: CancelTokenSource): Promise<UpsertTestLaboratoryDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const saveTestLaboratory = (upsertTestLaboratory: Partial<UpsertTestLaboratoryDto>, source: CancelTokenSource): Promise<UpsertTestLaboratoryDto> => {
  return axios
      .post(apiUri, upsertTestLaboratory, {cancelToken: source.token})
      .then(response => response.data);
};

export const editTestLaboratory = (id: number, upsertTestLaboratory: Partial<UpsertTestLaboratoryDto>, source: CancelTokenSource): Promise<TestLaboratoryDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertTestLaboratory, {cancelToken: source.token})
      .then( response => response.data);
};

export const deleteTestLaboratory = (id: number, source: CancelTokenSource): Promise<TestLaboratoryDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then( response => response.data);
};


